$(document).ready(function() {
  $('.datepicker').pickadate({
		format: 'dd/mm/yyyy',
		formatSubmit: 'dd/mm/yyyy',
		min: 'now',
  });
});